<div class="tabs_container_irlDetails" aria-live="assertive">
  <div class="tabsHeader">
    <div
      class="tab_base"
      [ngClass]="{ tab_select: selectedTab === TabNames.FareDetails }"
      (click)="selectTab(TabNames.FareDetails)"
      (keydown.enter)="selectTab(TabNames.FareDetails)"
      tabindex="0"
      role="button"
      i18n="@@itemDetailsFaredetails"
    >
      Fare Details
    </div>
    <div
      class="tab_base"
      [ngClass]="{ tab_select: selectedTab === TabNames.RailLegTimes }"
      (keydown.enter)="selectTab(TabNames.RailLegTimes)"
      (click)="selectTab(TabNames.RailLegTimes)"
      tabindex="0"
      role="button"
      i18n="@@itemDetailsRailtLegTimes"
    >
      Show Details
    </div>
  </div>
  @if (selectedTab === TabNames.FareDetails) {
    <div class="pane" id="0" Title="TabNames.FareDetails">
      @if (second.length) {
        <div class="type">2nd class</div>
      }
      <div class="tickets">
        @for (option of second; track option) {
          <div class="ticket">
            <span class="leg">
              <div>
                <b>{{ getClassName(option.class) }}:</b>
              </div>
              <label class="ticket-option-type">{{ option.type }}</label>
              <a
                class="fare_rules_link"
                (click)="openFareRulesModal(option)"
                (keydown.enter)="openFareRulesModal(option)"
                tabindex="0"
                role="link"
              >
                <i class="currency_info_icon"></i>
                <span i18n="@@irlTypeBrandedFareRules">Fare Rules</span></a
              ><br />
            </span>
            <span class="floatright">
              <div class="irl-price-details">
                <div class="star-container">
                  @if (option.fareInfo.code) {
                    <section class="container" (mouseleave)="tt1.close()">
                      <i
                        class="ico-star"
                        ngbTooltip="Company Negotiated Rate"
                        i18n-ngbTooltip
                        triggers="manual"
                        #tt1="ngbTooltip"
                        (mouseenter)="tt1.open()"
                        (focus)="tt1.open()"
                        (blur)="tt1.close()"
                        tabindex="0"
                      >
                      </i>
                    </section>
                  }
                </div>
                <div class="cost">
                  {{ option.price | currency: currency : 'symbol' }}
                  @if (discountCard) {
                    <section class="container" (mouseleave)="ttPercentage.close()">
                      <span
                        class="percentage-icon"
                        tooltipClass="custom-tooltip"
                        i18n-ngbTooltip
                        [ngbTooltip]="discountCard"
                        #ttPercentage="ngbTooltip"
                        (mouseenter)="ttPercentage.open()"
                        (focus)="ttPercentage.open()"
                        (blur)="ttPercentage.close()"
                        >%</span
                      >
                    </section>
                  }
                </div>
              </div>
              <button (click)="addToBasket(option)" [disabled]="disabledCheck()" class="link">
                {{ (option.selected ? 'Deselect' : 'Select') | translate }}
              </button>
              <br />
            </span>
            @if (showDebug) {
              <button (click)="alwaysLog(option)">Dump</button>
            }
          </div>
        }
      </div>
      @if (first.length) {
        <div class="type">1st class</div>
      }
      <div class="tickets">
        @for (option of first; track option) {
          <div class="ticket">
            <span class="leg">
              <div>
                <b>{{ getClassName(option.class) }}:</b>
              </div>
              <div>
                <label class="ticket-option-type">{{ option.type }}</label>
              </div>
              <a
                class="fare_rules_link"
                (click)="openFareRulesModal(option)"
                (keydown.enter)="openFareRulesModal(option)"
                tabindex="0"
                role="link"
              >
                <i class="currency_info_icon"></i>
                <span i18n="@@irlTypeBrandedFareRules">Fare Rules</span></a
              ><br />
            </span>
            <span class="floatright">
              <div class="irl-price-details">
                <div class="star-container">
                  @if (option.fareInfo.code) {
                    <section class="container" (mouseleave)="tt2.close()">
                      <i
                        class="ico-star"
                        ngbTooltip="Company Negotiated Rate"
                        i18n-ngbTooltip
                        triggers="manual"
                        #tt2="ngbTooltip"
                        (mouseenter)="tt2.open()"
                        (focus)="tt2.open()"
                        (blur)="tt2.close()"
                        tabindex="0"
                      >
                      </i>
                    </section>
                  }
                </div>
                <div class="cost">
                  {{ option.price | currency: currency : 'symbol' }}
                  @if (discountCard) {
                    <section class="container" (mouseleave)="ttPercentage2.close()">
                      <span
                        class="percentage-icon"
                        tooltipClass="custom-tooltip"
                        i18n-ngbTooltip
                        [ngbTooltip]="discountCard"
                        tabindex="0"
                        triggers="manual"
                        #ttPercentage2="ngbTooltip"
                        (mouseenter)="ttPercentage2.open()"
                        (focus)="ttPercentage2.open()"
                        (blur)="ttPercentage2.close()"
                        >%</span
                      >
                    </section>
                  }
                </div>
              </div>
              <button (click)="addToBasket(option)" [disabled]="disabledCheck()" class="link">
                {{ (option.selected ? 'Deselect' : 'Select') | translate }}
              </button>
              <br />
            </span>
          </div>
        }
      </div>
    </div>
  }
  @if (selectedTab === TabNames.RailLegTimes) {
    <div class="pane" id="1">
      <div class="leg_wrapper">
        <div class="leg_container">
          <app-irl-legs [legs]="legs" [trainNumber]="trainNumber"> </app-irl-legs>
        </div>
      </div>
    </div>
  }
</div>
